import { Component, Input, Output, EventEmitter, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Food } from 'src/interfaces/food.model';
import { LocalizationService } from 'src/app/services/localization.service';
import { MatDialog } from '@angular/material/dialog';
import { cloneDeep } from 'lodash-es';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BasketService } from 'src/app/services/basket.service';
import { DataService } from 'src/app/services/data.service';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { MenuFoodRecomendationDialogComponent } from '../menu-food-recomendation-dialog/menu-food-recomendation-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';
import { Locale } from 'src/interfaces/locale.model';
import { NO_PHOTO } from 'src/app/utils/no-photo';

@Component({
    selector: 'app-menu-recomendation-card-food',
    templateUrl: './menu-recomendation-card-food.component.html',
    styleUrls: ['./menu-recomendation-card-food.component.css'],
    standalone: false
})
export class MenuRecomendationCardFoodComponent implements OnDestroy {
  constructor(
    private basketService: BasketService,
    private dataService: DataService, 
    public localization: LocalizationService,
    private imageCache: ImageCacheService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.basketFoods = [];
    this.locale = this.dataService.locale;

    // Получаем ширину экрана
    this.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    this.vw = Math.min(this.vw, 480);
  }

  @Input() food!: Food;

  locale: Locale | null = null;

  // Подписываемся на изменения корзины
  private destroy$ = new Subject<void>();
  private basketFoods: Food[];
  
  // Получаем ширину экрана
  private vw: number;
  width: number = 220;
  height: number = 100;

  // Изображение заглушка
  imageSrc: string = NO_PHOTO.food;

  ngOnInit(): void {
    this.basketService.foods
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: Food[]) => {
      this.basketFoods = data;
    });

    // Image
    if (this.food?.image?.trim()) {
      this.imageCache.getImage(this.food.image, NO_PHOTO.food).then(src => {
        this.imageSrc = src;
      });
    }
  }

  ngAfterViewInit() {
    this.width = (Math.min(this.vw || 480) - 18) / 1.6;
    this.height = this.width * 0.40;
    this.cdr.detectChanges(); // Обновляем Angular-поток изменений
  }

  handleClick(event: MouseEvent): void {
    // Затемняем строку состояния перед открытием модального окна
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#717075');
    this.cdr.detectChanges(); // Обновляем Angular-поток изменений

    const basketFood = this.getBasketFood();
    const dialogRef = this.dialog.open(MenuFoodRecomendationDialogComponent,
      sheetDialogConfig(basketFood ? cloneDeep(basketFood) : cloneDeep(this.food)));

    dialogRef.afterClosed().subscribe(() => {
      // Возвращаем исходный цвет строки состояния
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#a6a6ae');
      this.cdr.detectChanges(); // Обновляем Angular-поток изменений
    });

    event.stopPropagation();
  }

  getBasketFood(): Food | null {
    return this.basketFoods.find(f => f.id === this.food.id) || null;
  }

  ngOnDestroy(): void {
    // Отписка при уничтожении компонента
    this.destroy$.next();
    this.destroy$.complete();
  }
}